module.exports = __webpack_public_path__ + "static/media/PYT_SE.c3c52279.png";